import AccountConstants from './AccountConstants';

export function currentAccountId(state = null, action) {
    switch (action.type) {
        case AccountConstants.ACCOUNT_SELECTED:
            return action.payload.id;
            break;
        default:
            return state;
    }
}

export function currentRole(state = null, action) {
    switch (action.type) {
        case AccountConstants.ACCOUNT_SELECTED:
            return action.payload.role;
            break;
        default:
            return state;
    }
}

export function accounts(state = {}, action) {
    switch (action.type) {
        case AccountConstants.ACCOUNT_RECEIVED:
            const newState = {
                ...state
            };

            const account = action.payload;

            newState[account.id] = {
                id: account.id.toString(),
                name: account.name,
                slug: account.slug,
                website: account.website,
                timezone: account.timezone,
                role: account.role,
            };

            return newState;
        default:
            return state;
    }
}


